export const SCSS_VARS = {
    '$leader-line-color': '#86cce4',
    '$leader-line-labels-color': 'rgba(60,112,164,0.6)',
    '$flow-definition-list-card-height': '112px',
    '$context-card-top-offset': '-70px'
};
